import { render, staticRenderFns } from "./VuesticLayout.vue?vue&type=template&id=c985c7f8&scoped=true"
import script from "./VuesticLayout.vue?vue&type=script&lang=js"
export * from "./VuesticLayout.vue?vue&type=script&lang=js"
import style0 from "./VuesticLayout.vue?vue&type=style&index=0&id=c985c7f8&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c985c7f8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/pagsmile/front-end/pagsmile-dashboard/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c985c7f8')) {
      api.createRecord('c985c7f8', component.options)
    } else {
      api.reload('c985c7f8', component.options)
    }
    module.hot.accept("./VuesticLayout.vue?vue&type=template&id=c985c7f8&scoped=true", function () {
      api.rerender('c985c7f8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/vuestic-theme/vuestic-components/vuestic-layout/VuesticLayout.vue"
export default component.exports